import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '../../../assets/img/icons/eye.svg'
import _imports_1 from '../../../assets/img/icons/edit.svg'
import _imports_2 from '../../../assets/img/icons/close.svg'


const _hoisted_1 = { class: "card border-0 shadow-none rounded-1 mb-25" }
const _hoisted_2 = { class: "card-body p-xl-40" }
const _hoisted_3 = { class: "py-4 text-center text-muted" }
const _hoisted_4 = {
  key: 0,
  class: "fw-semibold text-primary"
}
const _hoisted_5 = {
  key: 3,
  class: "d-flex justify-content-center gap-2 table-actions"
}
const _hoisted_6 = ["title", "onClick"]
const _hoisted_7 = ["alt"]
const _hoisted_8 = ["title", "onClick"]
const _hoisted_9 = ["alt"]
const _hoisted_10 = ["title", "onClick"]
const _hoisted_11 = ["alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_table, {
        columns: _ctx.columns,
        "data-source": _ctx.customers,
        "row-key": 'id',
        loading: _ctx.loading,
        pagination: _ctx.paginationConfig,
        scroll: { x: 1280 },
        class: "text-nowrap align-middle people-table"
      }, {
        emptyText: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.t("customer_page.no_customers_found")), 1)
        ]),
        bodyCell: _withCtx(({ column, record }) => [
          (column && column.key === 'code')
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(record.code || _ctx.t("customer_page.not_available_short")), 1))
            : (column && column.key === 'deposit')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(_ctx.formatCurrency(record.deposit)), 1)
                ], 64))
              : (column && column.key === 'status')
                ? (_openBlock(), _createElementBlock("span", {
                    key: 2,
                    class: _normalizeClass(["status-badge", Number(record.status || 0) === 1 ? 'status-active' : 'status-inactive'])
                  }, _toDisplayString(Number(record.status || 0) === 1 ? _ctx.t("customer_page.status_active") : _ctx.t("customer_page.status_inactive")), 3))
                : (column && column.key === 'actions')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("button", {
                        class: "btn p-0 border-0 action-icon-btn",
                        title: _ctx.t('customer_page.view'),
                        "data-bs-toggle": "modal",
                        "data-bs-target": "#customerDetailsModal",
                        onClick: ($event: any) => (_ctx.$emit('view-customer', record))
                      }, [
                        _createElementVNode("img", {
                          src: _imports_0,
                          alt: _ctx.t('customer_page.view'),
                          style: {"width":"14px"}
                        }, null, 8, _hoisted_7)
                      ], 8, _hoisted_6),
                      _createElementVNode("button", {
                        class: "btn p-0 border-0 action-icon-btn",
                        title: _ctx.t('customer_page.edit'),
                        "data-bs-toggle": "modal",
                        "data-bs-target": "#customerCreateModal",
                        onClick: ($event: any) => (_ctx.$emit('edit-customer', record))
                      }, [
                        _createElementVNode("img", {
                          src: _imports_1,
                          alt: _ctx.t('customer_page.edit'),
                          style: {"width":"14px"}
                        }, null, 8, _hoisted_9)
                      ], 8, _hoisted_8),
                      _createElementVNode("button", {
                        class: "btn p-0 border-0 action-icon-btn",
                        title: _ctx.t('customer_page.delete'),
                        onClick: ($event: any) => (_ctx.$emit('delete-customer', record))
                      }, [
                        _createElementVNode("img", {
                          src: _imports_2,
                          alt: _ctx.t('customer_page.delete'),
                          style: {"width":"14px"}
                        }, null, 8, _hoisted_11)
                      ], 8, _hoisted_10)
                    ]))
                  : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["columns", "data-source", "loading", "pagination"])
    ])
  ]))
}